import { render, staticRenderFns } from "./serviceExpires.vue?vue&type=template&id=2074f234&scoped=true"
import script from "./serviceExpires.vue?vue&type=script&lang=js"
export * from "./serviceExpires.vue?vue&type=script&lang=js"
import style0 from "./serviceExpires.vue?vue&type=style&index=0&id=2074f234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2074f234",
  null
  
)

export default component.exports